import React, { useState } from "react";

const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxhEEJiStejOy0_xOEpAdf6gAyWNL1od-wRlESdmOZO1fI5859VQYjQj2aQM-Cgi7v0/exec";

const Mail = () => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      setError("Enter a valid email.");
      return;
    }

    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("email", email);

      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: formData,
      });

      // Trigger PDF download
      const link = document.createElement("a");
      link.href = "/DIAG_Whitepaper.pdf";
      link.download = "DIAG_Whitepaper.pdf";
      link.click();

      setEmail("");
      setShowModal(false);
    } catch (err) {
      setError("Something went wrong. Try again.");
    }

    setSubmitting(false);
  };

  return (
    <>
      <button className="btn mb-4" onClick={() => setShowModal(true)}>
        Read Whitepaper
      </button>

      {showModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <p className="text-black merriweather-sans"><b className="text-black">Enter your email to download the Whitepaper</b></p>
            <input
              type="email"
              placeholder="abcd@gmail.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              style={styles.input}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div>
              <button
                onClick={handleSubmit}
                style={styles.button} className="merriweather-sans text-black"
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit & Download"}
              </button>
              <button onClick={() => setShowModal(false)} style={styles.button} className="merriweather-sans">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 8,
    textAlign: "center",
    margin:"10px",
  },
  input: {
    padding: 8,
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
  button: {
    margin: "0 5px",
    padding: "6px 12px",
    borderRadius: "50px",
    backgroundColor:"black",
    border: "1px solid black",
  },
};

export default Mail;
